// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/service_definition.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { GroupedDefinition, GroupedDefinitionJson, OneOfDefinition, OneOfDefinitionJson } from "./compound_services_pb";
import { file_mochabugapis_adapt_plugins_v1_compound_services } from "./compound_services_pb";
import type { HttpProxyDefinition, HttpProxyDefinitionJson } from "./http_proxy_service_pb";
import { file_mochabugapis_adapt_plugins_v1_http_proxy_service } from "./http_proxy_service_pb";
import type { Oauth2Definition, Oauth2DefinitionJson } from "./oauth2_service_pb";
import { file_mochabugapis_adapt_plugins_v1_oauth2_service } from "./oauth2_service_pb";
import type { VariableDefinition, VariableDefinitionJson } from "./variable_service_pb";
import { file_mochabugapis_adapt_plugins_v1_variable_service } from "./variable_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/service_definition.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_service_definition: GenFile = /*@__PURE__*/
  fileDesc("CjZtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS9zZXJ2aWNlX2RlZmluaXRpb24ucHJvdG8SHW1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxIqMEChFTZXJ2aWNlRGVmaW5pdGlvbhIzCgRuYW1lGAEgASgJQiW6SCJyIBABGGQyGl5bXyRhLXpBLVpdW18kYS16QS1aMC05XSokEhgKBWxhYmVsGAIgASgJQgm6SAZyBBABGGQSJAoLZGVzY3JpcHRpb24YAyABKAlCCrpIB3IFEAEY+gFIAYgBARIVCghvcHRpb25hbBgEIAEoCEgCiAEBEkUKCHZhcmlhYmxlGAUgASgLMjEubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuVmFyaWFibGVEZWZpbml0aW9uSAASQQoGb2F1dGgyGAYgASgLMi8ubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuT2F1dGgyRGVmaW5pdGlvbkgAEkgKCmh0dHBfcHJveHkYByABKAsyMi5tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MS5IdHRwUHJveHlEZWZpbml0aW9uSAASQQoFZ3JvdXAYCCABKAsyMC5tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MS5Hcm91cGVkRGVmaW5pdGlvbkgAEj8KBW9uZW9mGAkgASgLMi4ubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuT25lT2ZEZWZpbml0aW9uSABCDQoEdHlwZRIFukgCCAFCDgoMX2Rlc2NyaXB0aW9uQgsKCV9vcHRpb25hbGIGcHJvdG8z", [file_buf_validate_validate, file_mochabugapis_adapt_plugins_v1_compound_services, file_mochabugapis_adapt_plugins_v1_http_proxy_service, file_mochabugapis_adapt_plugins_v1_oauth2_service, file_mochabugapis_adapt_plugins_v1_variable_service]);

/**
 * The service definition - a flat declaration of a service that can be referenced by bindings.
 *
 * ## Architecture Principle: Service Definitions Are Always Flat
 *
 * Service definitions exist ONLY at the Manifest.service_definitions level and are NEVER nested.
 * Each definition has a unique name and a specific type (Variable, OAuth2, HTTP Proxy, Group, OneOf).
 *
 * ## Referencing from Service Lists
 *
 * Service lists (Manifest.system_services and Vertex.user_services) are string arrays that
 * directly reference service definitions by name. Each string must match a ServiceDefinition's `name`.
 *
 * ## Service Types
 *
 * - **VariableDefinition**: JSON variable with schema validation
 * - **Oauth2Definition**: OAuth2 authentication (various grant types)
 * - **HttpProxyDefinition**: HTTP proxy with TLS and header injection
 * - **GroupedDefinition**: References multiple other flat definitions as a group
 * - **OneOfDefinition**: Allows user to choose one from multiple flat definitions
 *
 * ## Example
 *
 * ```protobuf
 * // In Manifest.service_definitions
 * [
 *   { name: "api_key", variable: { schema: {...} } },
 *   { name: "oauth", oauth2: { grant_type: AUTHORIZATION_CODE, ... } },
 *   { name: "proxy", http_proxy: { allowed_hosts: [...], ... } }
 * ]
 *
 * // Referenced in service lists (strings matching service definition names)
 * system_services: ["oauth"]
 * ```
 *
 * @generated from message mochabugapis.adapt.plugins.v1.ServiceDefinition
 */
export type ServiceDefinition = Message<"mochabugapis.adapt.plugins.v1.ServiceDefinition"> & {
  /**
   * 'name' is the identifier of the service, referenced in code
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 'label' is a human-friendly label shown in the UI
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * 'description' is an optional detailed description of the service
   *
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * Whether this service is optional.
   *
   * If false (default):
   * - User MUST configure this service during installation
   * - Plugin can safely assume the service exists
   *
   * If true:
   * - User MAY skip configuring this service
   * - Plugin must handle the service being absent
   * - Useful for optional features (analytics, monitoring, etc.)
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean | undefined;

  /**
   * The actual type of service that the definition is
   *
   * @generated from oneof mochabugapis.adapt.plugins.v1.ServiceDefinition.type
   */
  type: {
    /**
     * Variable service containing arbitrary JSON
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.VariableDefinition variable = 5;
     */
    value: VariableDefinition;
    case: "variable";
  } | {
    /**
     * An OAuth2 service
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.Oauth2Definition oauth2 = 6;
     */
    value: Oauth2Definition;
    case: "oauth2";
  } | {
    /**
     * HTTP proxy service with TLS and header injection
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.HttpProxyDefinition http_proxy = 7;
     */
    value: HttpProxyDefinition;
    case: "httpProxy";
  } | {
    /**
     * A group definition, requiring it to be submitted as a group
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.GroupedDefinition group = 8;
     */
    value: GroupedDefinition;
    case: "group";
  } | {
    /**
     * A oneof definition, allowing one of several sub-definitions to be chosen
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.OneOfDefinition oneof = 9;
     */
    value: OneOfDefinition;
    case: "oneof";
  } | { case: undefined; value?: undefined };
};

/**
 * The service definition - a flat declaration of a service that can be referenced by bindings.
 *
 * ## Architecture Principle: Service Definitions Are Always Flat
 *
 * Service definitions exist ONLY at the Manifest.service_definitions level and are NEVER nested.
 * Each definition has a unique name and a specific type (Variable, OAuth2, HTTP Proxy, Group, OneOf).
 *
 * ## Referencing from Service Lists
 *
 * Service lists (Manifest.system_services and Vertex.user_services) are string arrays that
 * directly reference service definitions by name. Each string must match a ServiceDefinition's `name`.
 *
 * ## Service Types
 *
 * - **VariableDefinition**: JSON variable with schema validation
 * - **Oauth2Definition**: OAuth2 authentication (various grant types)
 * - **HttpProxyDefinition**: HTTP proxy with TLS and header injection
 * - **GroupedDefinition**: References multiple other flat definitions as a group
 * - **OneOfDefinition**: Allows user to choose one from multiple flat definitions
 *
 * ## Example
 *
 * ```protobuf
 * // In Manifest.service_definitions
 * [
 *   { name: "api_key", variable: { schema: {...} } },
 *   { name: "oauth", oauth2: { grant_type: AUTHORIZATION_CODE, ... } },
 *   { name: "proxy", http_proxy: { allowed_hosts: [...], ... } }
 * ]
 *
 * // Referenced in service lists (strings matching service definition names)
 * system_services: ["oauth"]
 * ```
 *
 * @generated from message mochabugapis.adapt.plugins.v1.ServiceDefinition
 */
export type ServiceDefinitionJson = {
  /**
   * 'name' is the identifier of the service, referenced in code
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * 'label' is a human-friendly label shown in the UI
   *
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * 'description' is an optional detailed description of the service
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * Whether this service is optional.
   *
   * If false (default):
   * - User MUST configure this service during installation
   * - Plugin can safely assume the service exists
   *
   * If true:
   * - User MAY skip configuring this service
   * - Plugin must handle the service being absent
   * - Useful for optional features (analytics, monitoring, etc.)
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean;

  /**
   * Variable service containing arbitrary JSON
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.VariableDefinition variable = 5;
   */
  variable?: VariableDefinitionJson;

  /**
   * An OAuth2 service
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.Oauth2Definition oauth2 = 6;
   */
  oauth2?: Oauth2DefinitionJson;

  /**
   * HTTP proxy service with TLS and header injection
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.HttpProxyDefinition http_proxy = 7;
   */
  httpProxy?: HttpProxyDefinitionJson;

  /**
   * A group definition, requiring it to be submitted as a group
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.GroupedDefinition group = 8;
   */
  group?: GroupedDefinitionJson;

  /**
   * A oneof definition, allowing one of several sub-definitions to be chosen
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.OneOfDefinition oneof = 9;
   */
  oneof?: OneOfDefinitionJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.ServiceDefinition.
 * Use `create(ServiceDefinitionSchema)` to create a new message.
 */
export const ServiceDefinitionSchema: GenMessage<ServiceDefinition, {jsonType: ServiceDefinitionJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_service_definition, 0);

